<template>
<div class="search-box">
  <form v-on:submit.prevent="search">
    <input type="text" placeholder="Type to search" v-model="q" />
    <button>Search</button>
  </form>
</div>
</template>
<script>
export default {
  data: ()=>({
    q: "",
  }),
  watch: {
    "$route.query.q": { immediate: true, handler() {
      this.q=""+(this.$route.query.q || "");
    }},
  },
  methods: {
    search() {
      this.$router.push({name: "home", query: {q: this.q}});
    },
  },
}
</script>
